import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty, get, find, isUndefined, filter, sumBy } from "lodash";
import { previewVoucher, mergeNames } from '../../../../../global/globalFunctions'
import { setHeading } from "../../../accounts/account.actions";
import { GetLevelFourDropDownApi } from "../LevelFour/LevelFourAction";
import { AddVoucherApi, SubmitBankRecipet, DeleteBankRecipet, ResetBankRecipet } from "./VoucherAction";
import Spinner from "react-bootstrap/Spinner";
import Select from "react-select";
import MaterialTable from "material-table";
import Swal from 'sweetalert';
import moment from 'moment';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const BankReceiptVoucher = (props) => {
    const [accountNo, setaccountNo] = useState();
    const [cashAccountTitle, setCashAccountTitle] = useState();
    const [selectedAccount, setSelectedAccount] = useState();
    const [cashId, setCashId] = useState("6439ac55391c16046483883b");
    const [cashAccountTitleKey, setCashAccountTitleKey] = useState();
    const [voucher, setVoucher] = useState();
    const [level4Id, setLevel4Id] = useState(2);
    const [datestate, setDatestate] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [visibleAlert, setAlertVisible] = useState(false);
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


    const SaveBankReceiptVoucher = () => {
        let dt = cash.map((x) => {
            return x.bankReceiptData;
        })
        let cashData = [{
            voucherDescription: mergeNames(dt, 'voucherDescription'),
            voucherAmount: sumBy(cash, item => Number(item.bankReceiptData.voucherAmount)),
            billNumber: mergeNames(dt, 'billNumber'),
            accountTittle: cashAccountTitle,
            levelFourId: accountNo,
            voucherDate: datestate,
            accountType: "2",
            crossAccount: mergeNames(dt, 'accountTittle'),
            debit: sumBy(cash, item => Number(item.bankReceiptData.voucherAmount)),
            credit: "",
            chequeNo: mergeNames(dt, 'chequeNo'),
            chequeDate: mergeNames(dt, 'chequeDate'),
        }]
        props.AddVoucherApi({
            voucherTypeId: "4",
            vocDate: datestate,
            levelFourId: accountNo,
            cashAccTittle: cashAccountTitle,
            totalAmount: sumBy(cash, item => Number(item.bankReceiptData.voucherAmount)),
            voucher: voucher,
            voucherData: [...dt, ...cashData],
            voucherType: "BRV",
        },
            handleVisible,
            handleDangerVisible
        );
        props.ResetBankRecipet();
    };
    const handleVisible = (data, msg) => {
        setAlertVisible(true)
        setTimeout(() => {
            setAlertVisible(false)
        }, 9000);
        Swal({
            title: "Success",
            text: msg,
            icon: "success",
            buttons: ["Cancel", "Print Voucher"]
        }).then((willPrint) => {
            if (willPrint) {
                previewVoucher(data, "Pending");
            }
        })
    }
    const handleDangerVisible = (err) => {
        setDangerVisibleAlert(true)
        setTimeout(() => {
            setDangerVisibleAlert(false)
        }, 9000);
        Swal({
            title: "Error",
            text: err,
            icon: "error",
            button: "Ok",
        });
    }

    const cash = props.bankRecipet;
    const [values, setValues] = useState({
        voucherDescription: "",
        voucherAmount: "",
        billNumber: "",
        accountTittle: "",
        levelFourId: "",
        voucherDate: "",
        accountType: "1",
        credit: "",
        debit: "",
        crossAccount: "",
        chequeNo: "",
        chequeDate: "",
    });

    const inputEvent = (event) => {
        event.target.name == "voucherDate" && setDatestate(event.target.value);
        if (event.target.name == "voucherAmount") {
            setValues({
                ...values,
                [event.target.name]: event.target.value,
                credit: Number(event.target.value)
            })
        } else {
            setValues({
                ...values,
                [event.target.name]: event.target.value,
            })
        }
    };

    const inputEventAccount = (selectedOption, type) => {
        setLevel4Id(selectedOption.value);
        setValues({
            levelFourId: selectedOption.value,
        });
    };

    const inputEvent1Account = (selectedOption) => {
        setLevel4Id(selectedOption.value);
        setValues({
            ...values,
            "levelFourId": selectedOption.value,
            "accountTittle":
                get(find(props.levelFourDropDownList, (x) => x._id === selectedOption.value), "levelFourName", 0) + "(" +
                get(find(props.levelFourDropDownList, (x) => x._id === selectedOption.value), "allLevelKey", 0) + ")",
        });
    };

    const handleChangeAccountNo = (selectedOption) => {
        setaccountNo(selectedOption.value);
        setCashAccountTitle(find(props.levelFourDropDownList, (x) => x._id === selectedOption.value).levelFourName);
        setCashAccountTitleKey(find(props.levelFourDropDownList, (x) => x._id === selectedOption.value).allLevelKey);
        setSelectedAccount(selectedOption.label)
    };
    const cashAccountNo = !isEmpty(props.levelFourDropDownList) && props.levelFourDropDownList.map((x) => {
        let data = {
            value: x._id,
            label: `${x.allLevelKey} / ${x.levelFourName}`,
        };
        return data
    });
    const cashAccountNoTop = !isEmpty(props.levelFourDropDownList) && props.levelFourDropDownList.filter(x => x.levelThreeId == cashId).map((y) => {
        let data = {
            value: y._id,
            label: `${y.allLevelKey} / ${y.levelFourName}`,
        };
        return data
    });


    const PostVoucher = () => {
        let newVal = values;
        if (!isEmpty(datestate)) newVal.voucherDate = datestate;
        props.SubmitBankRecipet(newVal);
        setValues({
            voucherDescription: "",
            voucherAmount: "",
            billNumber: "",
            accountTittle: "",
            levelFiveId: "",
            voucherDate: "",
            accountType: "1",
            credit: "",
            debit: "",
            crossAccount: "",
            chequeNo: "",
            chequeDate: "",
        });
    };

    useEffect(() => {
        props.setHeading("Bank Receipt Voucher");
        props.GetLevelFourDropDownApi();
    }, []);

    return (
        <>
            {props.isFetchingLevelFourDropDown ? (
                <div className="loader-div">
                    <Spinner
                        variant="primary"
                        animation="border"
                        size="xl"
                        role="status"
                        aria-hidden="true"
                    />
                </div>
            ) : (
                <div style={{ marginTop: '-2%' }}>
                    <Container fluid>
                        <Row>
                            <Col lg="4" sm="12">
                                <Form.Group >
                                    <Form.Label><b>Voucher Date *</b></Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="voucherDate"
                                        value={datestate}
                                        max={moment(new Date()).format("YYYY-MM-DD")}
                                        onChange={inputEvent}
                                        disabled={!isEmpty(props.bankPaymenta)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg="6" sm="12">
                                <Form.Group >
                                    <Form.Label><b>Select Bank Account *</b></Form.Label>
                                    <Select
                                        className="selectOptionColor"
                                        value={{ label: cashAccountTitle }}
                                        isDisabled={isUndefined(level4Id) || !isEmpty(accountNo)}
                                        placeholder="Select Bank Account"
                                        onChange={handleChangeAccountNo}
                                        options={filter(cashAccountNoTop, x => x.value !== values.levelFourId)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group >
                                    <Form.Label><b>Account Type *</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Account Type"
                                        name="accountType"
                                        value="Debit"
                                        disabled
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="6" sm="12">
                                <Form.Group >
                                    <Form.Label><b>Select Account *</b></Form.Label>
                                    <Select
                                        value={{ label: values.accountTittle }}
                                        placeholder="Select Account"
                                        onChange={(inputEventAccount, inputEvent1Account)}
                                        options={filter(cashAccountNo, x => x.value !== accountNo)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group >
                                    <Form.Label><b>Account Type *</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Account Type"
                                        value="Credit"
                                        disabled
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Form.Group >
                                    <Form.Label><b>Bill Number</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Bill Number"
                                        name="billNumber"
                                        value={values.billNumber}
                                        onChange={inputEvent}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group >
                                    <Form.Label><b>Description</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Description"
                                        // id="descriptionID"
                                        name="voucherDescription"
                                        value={values.voucherDescription}
                                        onChange={inputEvent}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group >
                                    <Form.Label><b>Voucher Amount *</b></Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Voucher Amount"
                                        // id="amountID"
                                        name="voucherAmount"
                                        value={values.voucherAmount}
                                        onChange={inputEvent}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group >
                                    <Form.Label><b>Cheque No</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Cheque No"
                                        name="chequeNo"
                                        value={values.chequeNo}
                                        onChange={inputEvent}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group >
                                    <Form.Label><b>Cheque Date</b></Form.Label>
                                    <Form.Control
                                        type="date"
                                        placeholder="Cheque Date"
                                        name="chequeDate"
                                        value={values.chequeDate}
                                        onChange={inputEvent}
                                    />
                                </Form.Group>
                            </Col>
                            <Col></Col>
                        </Row>

                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '80px', marginTop: '15px' }}>
                            <div>
                                <Button
                                    variant="contained"
                                    endIcon={<SendIcon />}
                                    size="large"
                                    disabled={isEmpty(level4Id) || isEmpty(accountNo) || isEmpty(values.voucherAmount)}
                                    onClick={() => { PostVoucher() }}>
                                    POST VOUCHER
                                </Button>
                            </div>
                            <div>
                                <Button
                                    variant="contained"
                                    endIcon={<SendIcon />}
                                    size="large"
                                    onClick={SaveBankReceiptVoucher}
                                    disabled={isEmpty(cash)}>
                                    SAVE VOUCHER
                                </Button>
                            </div>
                        </div>


                        <div className="main" style={{ marginTop: '10px' }} >
                            <MaterialTable
                                title={`VOUCHER TOTAL : ${sumBy(cash, item => Number(item.bankReceiptData.voucherAmount))}`}
                                columns={[
                                    { title: "Date", field: "bankReceiptData.voucherDate" },
                                    { title: "Account Name", field: "bankReceiptData.accountTittle" },
                                    { title: "Bill", field: "bankReceiptData.billNumber" },
                                    { title: "Description", field: "bankReceiptData.voucherDescription" },
                                    { title: "Cheque No", field: "bankReceiptData.chequeNo" },
                                    { title: "Cheque Date", field: "bankReceiptData.chequeDate" },
                                    { title: "Amount", field: "bankReceiptData.voucherAmount", render: rowData => `${rowData.bankReceiptData.voucherAmount}/-` },
                                    { title: "Debit / Credit", field: "bankReceiptData.accountType", render: (rowData) => rowData.bankReceiptData.accountType === "1" ? "Credit" : "Debit" },
                                ]}
                                data={cash}
                                options={{
                                    actionsColumnIndex: -1,
                                    exportButton: false,
                                    exportAllData: false,
                                    paging: false,
                                    pageSize: 50,
                                    emptyRowsWhenPaging: false,
                                    pageSizeOptions: [50, 100, 150, 200],
                                    headerStyle: {
                                        position: "sticky",
                                        top: 0,
                                        color: "#00BBBB",
                                        fontWeight: "550",
                                        onRowAdd: "none",
                                    },
                                }}
                                editable={{
                                    onRowDelete: (oldData) =>
                                        new Promise((resolve) => {
                                            setTimeout(() => {
                                                resolve();
                                                props.DeleteBankRecipet(oldData);
                                            }, 600);
                                        }),
                                }}
                            />
                        </div>

                    </Container>
                </div>
            )}
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        AddVoucherApi: (data, handleVisible, handleDangerVisible) => dispatch(AddVoucherApi(data, handleVisible, handleDangerVisible)),
        SubmitBankRecipet: (data) => dispatch(SubmitBankRecipet(data)),
        DeleteBankRecipet: (id) => dispatch(DeleteBankRecipet(id)),
        ResetBankRecipet: () => dispatch(ResetBankRecipet()),
        GetLevelFourDropDownApi: () => dispatch(GetLevelFourDropDownApi()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    bankRecipet: state.VouchersReducer.bankRecipet,
    isFetchingLevelFourDropDown: state.LevelFourReducer.isFetchingLevelFourDropDown,
    levelFourDropDownList: state.LevelFourReducer.levelFourDropDownList,
});


export default connect(mapStateToProps, mapDispatchToProps)(BankReceiptVoucher);